/*
 * Licensed Materials - Property of HCL Technologies Limited.
 * (C) Copyright HCL Technologies Limited 2024.
 */

export const UNUSED_PRODUCT_ATTRIBUTE_KEYS = {
	'attribute.natural': true,
	'attribute.store': true,
	merchandisable: true,
	searchable: true,
};

export const UNUSED_ATTRIBUTE_VALUE_KEYS = {
	unitOfMeasure: true,
	unitID: true,
	image1: true,
};
